// ATTP NEXUS — Module Registry (rebuilt per FSD Complete v1)
// 10 modules total: 6 paid (Financials, Estate, Offices, Education, Events, LMS) +
// 2 public sites (Engineering, Corporate Hub) + 2 additional paid (Healthcare = merged
// Hospital/Clinic + Pharmacy Store; HR = ATTP-HR Enterprise HCM).
import {
  Coins, Building2, Briefcase, GraduationCap,
  Award, BookOpen, Wrench, Briefcase as BriefcaseIcon, Stethoscope, Users,
} from 'lucide-react';

export const MODULES = [
  {
    id: 'financials', slug: 'financials',
    name: 'ATTP Financials & Asset Management',
    short: 'Financials & Asset Management',
    tagline: 'Finance · Assets · Procurement · Maintenance · Operations · Reporting.',
    description: 'A complete finance and asset control engine. Manage your accounts, invoices, budgets, assets, procurement, and maintenance — all connected in one system with no duplicate entry.',
    forWho: 'Companies, Schools, Estates, NGOs, Institutions',
    type: 'paid',
    accent: '#27AE60',
    icon: Coins, logo: '/logos/attp-financials.png',
  },
  {
    id: 'estate', slug: 'estate',
    name: 'ATTP for Estate',
    short: 'ATTP for Estate',
    tagline: 'Total estate operations. One dashboard.',
    description: 'Full estate operations management. From housing and hostel management to power, water, security, and vehicle tracking — every facility under one dashboard.',
    forWho: 'Residential estates, boarding schools, gated communities, institutional campuses',
    type: 'paid',
    accent: '#E67E22',
    icon: Building2, logo: '/logos/attp-main.png',
  },
  {
    id: 'offices', slug: 'offices',
    name: 'ATTP for Offices',
    short: 'ATTP for Offices',
    tagline: 'Smart office operations. Full visibility. Zero chaos.',
    description: 'Operational control for office environments. Manage ICT assets, facility bookings, procurement, power systems, security, and staff operations in one place.',
    forWho: 'Companies, firms, government offices, professional organisations',
    type: 'paid',
    accent: '#00BCD4',
    icon: Briefcase, logo: '/logos/attp-main.png',
  },
  {
    id: 'education', slug: 'education',
    name: 'ATTP for Education',
    short: 'ATTP for Education',
    tagline: 'Built for schools. Designed for everything schools need.',
    description: 'Built for schools and educational institutions. Covers finance, fee management, hostel, library, laboratory, clinic, kitchen, ICT, and all facility operations — purpose-built for education.',
    forWho: 'Schools, universities, training institutions, boarding schools',
    type: 'paid',
    accent: '#F39C12',
    icon: GraduationCap, logo: '/logos/attp-main.png',
  },
  {
    id: 'events', slug: 'events',
    name: 'ATTP Events & Certifier',
    short: 'Events & Certifier',
    tagline: 'Smart events. Secure access. Verified certificates.',
    description: 'End-to-end event management, QR-based access control, and automated certificate issuance.',
    forWho: 'Schools, corporates, governments, training providers, certification bodies, estates',
    type: 'paid',
    accent: '#E91E63',
    icon: Award, logo: '/logos/attp-main.png',
  },
  {
    id: 'lms', slug: 'lms',
    name: 'ATTP Pathway Club',
    short: 'ATTP Pathway Club',
    tagline: 'Learn. Progress. Certify. No shortcuts.',
    description: 'A structured digital learning system built on mastery. Foundation → Intermediate → Professional → Specialist, with badges and certifications earned at each step.',
    forWho: 'Individuals, training organisations, schools, professional development programmes',
    type: 'paid',
    accent: '#FF6F00',
    icon: BookOpen, logo: '/logos/attp-main.png',
  },
  {
    id: 'healthcare', slug: 'healthcare',
    name: 'ATTP for Healthcare',
    short: 'Healthcare (Hospital, Clinic & Pharmacy)',
    tagline: 'Hospital, clinic, and pharmacy operations in one system.',
    description: 'EMR · OPD queue · vitals · lab orders · ward management · pharmacy stock · billing & HMO — designed for hospitals, clinics and dispensaries operating their own pharmacy store.',
    forWho: 'Hospitals, clinics, diagnostic centres, pharmacies, dispensaries',
    type: 'paid',
    accent: '#0EA5E9',
    icon: Stethoscope, logo: '/logos/attp-main.png',
  },
  {
    id: 'hr', slug: 'hr',
    name: 'ATTP-HR',
    short: 'ATTP-HR (Enterprise HCM)',
    tagline: 'The single source of truth for your entire workforce.',
    description: 'A fully integrated Enterprise Human Capital Management System covering workforce planning, recruitment, onboarding, payroll, performance, learning, succession, compensation, compliance and offboarding — built on Master Data Architecture with workflow-driven approvals, AI analytics and biometric integration.',
    forWho: 'Schools · Universities · Hospitals · Manufacturing · Banks · Government · NGOs · Conglomerates · Multi-country organisations',
    type: 'paid',
    accent: '#8B5CF6',
    icon: Users, logo: '/logos/attp-main.png',
  },
  {
    id: 'engineering', slug: 'engineering',
    name: 'ATTP Engineering',
    short: 'ATTP Engineering',
    tagline: 'Your trusted engineering partner.',
    description: 'Olu-Akintade Computer & Electrical Works Engineering — professional electrical installation, computer repairs, electronics servicing, and technical solutions.',
    forWho: 'Households · Estates · Schools · Corporate clients',
    type: 'public',
    accent: '#E63946',
    icon: Wrench, logo: '/logos/oluakin-engineering.png',
  },
  {
    id: 'corporate', slug: 'corporate',
    name: 'ATTP Corporate Hub',
    short: 'ATTP Corporate Hub',
    tagline: 'Building stronger African institutions.',
    description: 'Professional consulting, training, and education practice helping African organisations build structured systems and develop capable leaders.',
    forWho: 'Schools · Corporates · Government · NGOs · Boarding institutions',
    type: 'public',
    accent: '#C9A84C',
    icon: BriefcaseIcon, logo: '/logos/attp-corporate-hub.png',
  },
];

export const moduleBySlug = (slug) => MODULES.find((m) => m.slug === slug);
export const paidModules = () => MODULES.filter((m) => m.type === 'paid');
export const publicModules = () => MODULES.filter((m) => m.type === 'public');
